import { MenuItemDefinition } from '@neos/core'

export const menuItems: Record<string, MenuItemDefinition> = {
  AssignPermission: {
    to: 'AssignPermissionToRolesListUI',
  },
  Country: {
    to: 'CountryLookupUI',
  },
  Currency: {
    to: 'CurrencyLookupUI',
  },
  Municipality: {
    to: 'MunicipalityLookupUI',
  },
  Permission: {
    to: 'PermissionUI',
  },
  ProvinceState: {
    to: 'ProvinceStateLookupUI',
  },
  ReferencialCommunicationTemplates: {
    to: 'CommunicationTemplatesUI',
  },
  ReferencialCountry: {
    to: 'CountryUI',
  },
  ReferencialCurrency: {
    to: 'CurrencyUI',
  },
  ReferencialCustomerProfile: {
    to: 'CustomerProfileUI',
  },
  ReferencialDeveloperActions: {
    to: 'DeveloperMenuUI',
  },
  ReferencialDiscount: {
    to: 'DiscountUI',
  },
  ReferencialInvoicingSetting: {
    to: 'InvoicingSettingUI',
  },
  ReferencialMunicipality: {
    to: 'MunicipalityUI',
  },
  ReferencialPaymentMethod: {
    to: 'PaymentMethodUI',
  },
  ReferencialPaymentTerm: {
    to: 'PaymentTermUI',
  },
  ReferencialPriceList: {
    to: 'PriceListUI',
  },
  ReferencialPrintingSetting: {
    to: 'PrintingSettingUI',
  },
  ReferencialProductCategory: {
    to: 'ProductCategoryUI',
  },
  ReferencialProvinceState: {
    to: 'ProvinceStateUI',
  },
  ReferencialSalesTax: {
    to: 'SalesTaxUI',
  },
  ReferencialSalesTaxApplicable: {
    to: 'SalesTaxApplicableUI',
  },
  ReferencialSalesTaxException: {
    to: 'SalesTaxExceptionUI',
  },
  ReferencialUnit: {
    to: 'UnitUI',
  },
  ReferencialUnitType: {
    to: 'UnitTypeUI',
  },
  UserAccount: {
    to: 'UserAccountListUI',
  },
  UserAccountUserRole: {
    to: 'UserAccountUserRoleUI',
  },
  UserSettings: {
    to: 'UserSettingsUI',
  }
}